const ACRONYMS = new Set([
  'ID','CAD','USD','GST','HST','PST','VAT','UWI','BOL','ETA','POD',
  'API','URL','SMS','PDF','CSV','XML','JSON','SKU','PO','SO','AR','AP',
  'YTD','MTD','QTD','OT','PTO','EI','CPP','RBC','TD','FA','BHA',
  'OD','PSI','RPM','MD','TVD','KOP',
]);

const LOWERCASE_SHORT = new Set(['of','and','the','for','to','in','on','vs','by']);

/**
 * Convert a snake_case or camelCase column name to a Title Case display label.
 * Preserves known acronyms (CAD, USD, BOL, etc).
 *
 * Examples:
 *   customer_name       → "Customer Name"
 *   revenue_cad         → "Revenue CAD"
 *   amount_paid_to_date → "Amount Paid to Date"
 *   bolNumber           → "BOL Number"
 */
export function formatColumnHeader(raw: string): string {
  if (!raw) return '';

  // Normalize camelCase to snake_case
  const normalized = raw
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase();

  const words = normalized.split('_').filter(Boolean);

  return words.map((word, i) => {
    const upper = word.toUpperCase();
    if (ACRONYMS.has(upper)) return upper;
    if (i > 0 && LOWERCASE_SHORT.has(word)) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
}
